import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import ToDos from "./ToDos";

const App = () => {
    
    const [todo, setTodo] = useState(getTodoFromLS());
    const [addedTodo, setAddedTodo] = useState("");

    addTodoToLS(todo);

    const addTodo = () => {
        setTodo([...todo, addedTodo]);
        setAddedTodo("");
    };

    const enterKeyHandler = (e) => {
        if (e.key === "Enter" && addedTodo.length!=0) {
            setTodo([...todo, addedTodo]);
            setAddedTodo("");
        }
    };

    const removeTodo = (id) => {
        setTodo(() => todo.filter((todo, index) => index != id));
    };

    function addTodoToLS(todo) {
        localStorage.setItem("todoLS", JSON.stringify(todo));
    }

    function getTodoFromLS(){
        let LStodo = JSON.parse(localStorage.getItem("todoLS"));
        if(LStodo===null){
            return []
        }
        else{
            return LStodo;
        }
    };

    return (
        <div className="container">
            <div className="to-do-container">
                <h2>ToDo List</h2>
                <div>
                    <input
                        type="text"
                        value={addedTodo}
                        onChange={(e) => setAddedTodo(e.target.value)}
                        onKeyDown={enterKeyHandler}
                        placeholder="Add a Item"
                    />
                    <button
                        disabled={addedTodo.length === 0}
                        className="add-button"
                        onClick={addTodo}
                    >
                        <FaPlus size={25} />
                    </button>
                </div>
                <div className="to-dos">
                    {todo.map((value, index) => (
                        <ToDos key={index} id={index} removeTodo={removeTodo} toDo={value} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default App;
